export default __webpack_public_path__ + "static/media/Raymond3.574dff01.gif";